import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";

export default function SubpageHero({ crumb, eyebrow, title, intro, children }) {
  return (
    <section className="relative pt-24 sm:pt-36 pb-12 sm:pb-20 overflow-hidden">
      <div className="absolute inset-0 hero-glow pointer-events-none" />
      <div className="absolute inset-0 grid-bg pointer-events-none opacity-60" />
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 flex flex-col items-center text-center">
        <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-[12px] text-zinc-400">
          <Link to="/" className="hover:text-zinc-300 transition-colors">Home</Link>
          <CaretRight size={10} weight="bold" />
          <span className="text-zinc-400">{crumb}</span>
        </nav>
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mt-6 sm:mt-8 max-w-3xl flex flex-col items-center"
        >
          <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] pl-2 pr-4 py-1.5 text-[10.5px] tracking-[0.18em] uppercase text-zinc-400">
            <span className="block w-2 h-2 rounded-full bg-brand-500 pulse-dot" />
            {eyebrow}
          </div>
          <h1
            data-testid="subpage-h1"
            className="mt-6 font-display font-bold text-[36px] sm:text-5xl lg:text-[64px] leading-[1.02] tracking-tighter text-white"
          >
            {title}
          </h1>
          <p className="mt-5 sm:mt-6 text-[15px] sm:text-lg text-zinc-300 leading-relaxed max-w-2xl">
            {intro}
          </p>
          <div className="w-full flex flex-col items-center">{children}</div>
        </motion.div>
      </div>
    </section>
  );
}
